import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ro from './locales/ro.json'
import fr from './locales/fr.json'
import it from './locales/it.json'
import de from './locales/de.json'
import es from './locales/es.json'

// Define the messages
const messages = {
  en,
  ro,
  fr,
  it,
  de,
  es
}

// Create i18n instance
export const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'ro', // Default locale - English
  fallbackLocale: 'en', // Fallback locale - English
  messages,
  globalInjection: true, // Enable global $t, $tc, etc.
})

export default i18n
